/** `useQuery(input, { trpc: UNBATCHED })`: a batch answers only when its slowest query does. */
export const UNBATCHED = { context: { skipBatch: true } } as const;

export function isUnbatched(op: { context: Record<string, unknown> }): boolean {
  return op.context.skipBatch === true;
}
